import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import Modal from "@/common/elements/Modal";
import { StyledFlex } from "@/common/styles";
import { InmateDetailsTableContainer, TableHeader } from "@/components/InmateDetails/styles";
import { useState } from "react";
import TrainingClassForm from "./TrainingClassForm";

const TrainingClassDetails = ( ) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [tableData,setTableData] = useState({
        headers:[
            {key:"id",text:"ID"},
            {key:"className",text:"Class Name"},
            {key:"className",text:"Scheduled Date And Time"},
            {key:"completedDate",text:"Completed Date"},
            {key:"hours",text:"Hours"},
        ],
        rows:[]
    })

    const onHandleModalOpen = () => {
      setIsModalVisible(true)
    }
    const onHandleModalClose = () => {
      setIsModalVisible(false)
    }

    return(
        <>
        <InmateDetailsTableContainer>
                {false && <TableHeader>
                  <h6>Training</h6>
                  <StyledFlex gap="10px">
                    {/* <Button
                      color="primary"
                      type="primary"
                      onClick={onHandleModalVisible}>
                      Add
                    </Button> */}
                    <Button
                      color="primary"
                      type="primary"
                      onClick={onHandleModalOpen}>
                      Details
                    </Button>
                  </StyledFlex>
                </TableHeader>}

                <DataTable
                  headers={tableData.headers}
                  data={tableData.rows}
                />

              </InmateDetailsTableContainer>
              
              { isModalVisible && (
              <Modal 
              show={isModalVisible}
              header="Training Class Member Details"
              size="xl"
              handleCancel={onHandleModalClose}
              onHide={onHandleModalClose}>
                
                <TrainingClassForm />
              
              </Modal>
              )}
        </>
    )
} 
export default TrainingClassDetails;